import Vue from 'vue'
import Router from 'vue-router'
import Top from '@/components/Pages/Top'
import Hakodate from '@/components/Pages/Hakodate'
import Tokyo from '@/components/Pages/Tokyo'
import Exhibits from '@/components/Pages/Exhibits'
import ExhibitItem from '@/components/Pages/ExhibitItem'
import NotFound from '@/components/Pages/NotFound'

Vue.use(Router)

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  mode: 'history',
  base: '/sotsuten2019/',
  routes: [
    {
      path: '/',
      name: 'Top page',
      component: Top
    },
    {
      path: '/hakodate',
      name: 'Hakodate Exhibition',
      component: Hakodate
    },
    {
      path: '/tokyo',
      name: 'Tokyo Exhibition',
      component: Tokyo
    },
    {
      path: '/exhibits',
      name: 'Exhibits',
      component: Exhibits
    },
    {
      path: '/exhibits/:exhibitId',
      name: 'ExhibitItem',
      component: ExhibitItem,
      props: route => ({
        exhibitId: Number(route.params.exhibitId),
        studentNo: Number(route.params.studentNo)
      })
    },
    {
      path: '/404',
      name: '404 Page Not Found',
      component: NotFound
    },
    {
      path: '*',
      name: 'This Page May Not Be Found',
      redirect: '/404'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js